import { render, staticRenderFns } from "./RdPreferences.vue?vue&type=template&id=63ce7e0e&"
import script from "./RdPreferences.vue?vue&type=script&lang=js&"
export * from "./RdPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports